(function () {
var $872c939e1b91db7e$var$search = {
    toggleButton: null,
    searchForm: null,
    searchFormWrapper: null,
    searchInput: null,
    mobileMediaQuery: null,
    init: function() {
        var _this_searchForm;
        this.toggleButton = document.querySelector('.js-search-toggle');
        this.searchForm = document.querySelector('.js-search-form');
        this.searchFormWrapper = document.querySelector('.js-search-form-wrapper');
        this.searchInput = (_this_searchForm = this.searchForm) === null || _this_searchForm === void 0 ? void 0 : _this_searchForm.querySelector('#search');
        if (!this.toggleButton || !this.searchForm) return;
        this.mobileMediaQuery = window.matchMedia('(max-width: 782px)');
        this.bindEvents();
        this.handleResize();
    },
    bindEvents: function() {
        var _this = this;
        this.toggleButton.addEventListener('click', function(event) {
            return _this.handleToggle(event);
        });
        this.toggleButton.addEventListener('keydown', function(event) {
            return _this.handleKeydown(event);
        });
        document.addEventListener('keydown', function(event) {
            return _this.handleEscape(event);
        });
        document.addEventListener('click', function(event) {
            return _this.handleOutsideClick(event);
        });
        this.mobileMediaQuery.addEventListener('change', function() {
            return _this.handleResize();
        });
        this.searchForm.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') _this.handleTabbing(e);
        });
    },
    isOpen: function() {
        return this.toggleButton.getAttribute('aria-expanded') === 'true';
    },
    handleToggle: function(event) {
        if (!this.mobileMediaQuery.matches) return;
        event.stopPropagation();
        var isOpen = this.isOpen();
        isOpen ? this.close() : this.open();
    },
    handleKeydown: function(event) {
        if ([
            'Enter',
            ' '
        ].includes(event.key)) {
            event.preventDefault();
            this.handleToggle(event);
        }
    },
    handleEscape: function(event) {
        if (event.key === 'Escape' && this.toggleButton.getAttribute('aria-expanded') === 'true') {
            this.close();
            this.toggleButton.focus();
        }
    },
    handleOutsideClick: function(event) {
        var isOpen = this.isOpen();
        if (isOpen && !this.searchForm.contains(event.target) && !this.toggleButton.contains(event.target)) this.close();
    },
    open: function() {
        var _this = this;
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.searchForm.setAttribute('aria-hidden', 'false');
        this.searchFormWrapper.classList.add('is-active');
        setTimeout(function() {
            return _this.searchInput.focus();
        }, 300);
    },
    close: function() {
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.searchForm.setAttribute('aria-hidden', 'true');
        this.searchFormWrapper.classList.remove('is-active');
    },
    handleTabbing: function(event) {
        if (!this.mobileMediaQuery.matches) return;
        if (this.toggleButton.getAttribute('aria-expanded') !== 'true') return;
        var focusable = this.searchForm.querySelectorAll('input:not([disabled]), button:not([disabled])');
        if (!focusable || focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        }
    },
    handleResize: function() {
        if (!this.mobileMediaQuery.matches) {
            this.searchForm.removeAttribute('aria-hidden');
            this.toggleButton.removeAttribute('aria-expanded');
            this.searchFormWrapper.classList.add('is-active');
        } else if (this.toggleButton.getAttribute('aria-expanded') !== 'true') {
            this.searchForm.setAttribute('aria-hidden', 'true');
            this.toggleButton.setAttribute('aria-expanded', 'false');
            this.searchFormWrapper.classList.remove('is-active');
        }
    }
};
window.addEventListener('DOMContentLoaded', function() {
    return $872c939e1b91db7e$var$search.init();
});

})();
//# sourceMappingURL=script.js.map
